/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "2023-07-17:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Bank Info wajib terisi untuk membuka halaman saweria"
      }), "\n", _jsx(_components.li, {
        children: "Menambahkan fitur blur untuk panel saldo"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "2023-03-21:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "MediaShare sekarang memfilter konten yang tidak pantas."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "2023-01-24:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Bug fix pada halaman setting overlay"
      }), "\n", _jsx(_components.li, {
        children: "Custom CSS/HTML untuk overlay alert"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "2022-12-19:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Streamer dapat mengganti tombol quick amounts pada halaman saweria."
      }), "\n", _jsx(_components.li, {
        children: "Menampilkan jumlah minimum untuk mentrigger Alert dan TTS"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "2022-12-12:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Nama dan besar dukungan sekarang akan ikut dibaca saat TTS diaktifkan"
      }), "\n", _jsx(_components.li, {
        children: "Replay alert sekarang akan memutar TTS"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "2022-11-30:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Merapihkan Overlay Setting pada layar kecil (HP)."
      }), "\n", _jsx(_components.li, {
        children: "Merapihkan overlay leaderboard dan milestone."
      }), "\n", _jsx(_components.li, {
        children: "Overlay milestone sekarang menampilkan border pada bar."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "2022-11-29:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Pendukung harus menyetujui bahwa mereka berusia lebih dari 17 tahun untuk melakukan dukungan."
      }), "\n", _jsx(_components.li, {
        children: "Mengganti YT video pada notifikasi palsu mediashare menjadi video promo saweria."
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
